import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import Notify from "components/Common/notify"
import { returningStudentsFetchAPI } from "api/returningStudents/returningStudentsApiHelper"

export const ReturningStudentsFetch = createAsyncThunk(
  "ReturningStudents/ReturningStudentsFetch",
  async data => {
    try {
      const response = await returningStudentsFetchAPI(data)
      const _response = {
        data: response?.data,
        status: response?.status,
        withPagination: data?.pageSize > 0 ? true : false,
      }
      return _response
    } catch (error) {
      Notify("error", "Failed to fetch returning students.")
      throw Error("Failed to fetch returning students")
    }
  },
)

const initialState = {
  returningStudentsData: [],
  totalPages: 0,
  loading: false,
  error: null,
}

export const ReturningStudentsSlice = createSlice({
  name: "ReturningStudentsSlice",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(ReturningStudentsFetch.pending, state => {
        state.loading = true
        state.returningStudentsData = []
        state.error = null
      })
      .addCase(ReturningStudentsFetch.fulfilled, (state, action) => {
        state.loading = false
        state.totalPages = action.payload?.data?.data?.totalPages || 0
        state.returningStudentsData = action.payload?.data?.data?.items || []
      })
      .addCase(ReturningStudentsFetch.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })
  },
})

export const allReturningStudents = state => state.allReturningStudents

export default ReturningStudentsSlice.reducer
